import { Api } from 'utils';

class UserService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/users',params),
		find: async (params?: any) => Api.createResponse('admin/users/find',params),
		getSelects: async (params?: any) => Api.createResponse('admin/users/get-selects',params),
		getBanks: async (params?: any) => Api.createResponse('app/auth/banks',params),
		download: async (params?: any) => Api.createResponse('admin/users/download',params),
		delete: async (params?: any) => Api.createResponse('admin/users/delete',params),
		suspend: async (params?: any) => Api.createResponse('admin/users/suspend',params),
		createOrUpdate: async (params?: any) => Api.createResponse('admin/users/create-or-update',params),
		approveOrReject: async (params?: any) => Api.createResponse('admin/users/approve-or-reject',params),
		validateVendorCode: async (params?: any) => Api.createResponse('admin/users/check-seller-code',params),

		allPayments: async (params?: any) => Api.createResponse('admin/users/payments/all',params),
		approveOrRejectPayment: async (params?: any) => Api.createResponse('admin/users/payments/approve-or-reject',params),
		createPayment: async (params?: any) => Api.createResponse('admin/users/payments/pay',params),
		deletePayment: async (params?: any) => Api.createResponse('admin/users/payments/delete',params),
		
		getCommissions: async (params?: any) => Api.createResponse('admin/users/commissions',params),
		createCommissionPayment: async (params?: any) => Api.createResponse('admin/users/commissions/pay',params),
		deleteCommission: async (params?: any) => Api.createResponse('admin/users/commissions/delete',params),
	}

	static affiliate = {
		getSelects: async (params?: any) => Api.createResponse('app/affiliate/get-selects',params),
	}

}

export default UserService;